/**
 * MWF Nav Tabs
 *
 * This script is a hybrid approach to introducing Moray into the MSR website.
 * In order to follow design specs, we opt to use the Moray Nav component
 * as opposed to the Moray Tab component. However, we still want to provide a
 * Tab like experience, and this allows us to add that functionality to the Nav
 * component, essentially treating them like tabs. This depends on specific utility
 * CSS from Moray, but not the Moray JS.
 */
( function() {
	const mwfNavTabContainers = document.querySelectorAll( '.js-mwf-nav-tabs' );
	const currentHash = window.location.hash;

	// Setup on each hybrid tabs group
	mwfNavTabContainers.forEach( setupMwfNavTabDelegations );

	// Check with window if an active tab should load
	mwfHashChangedHandler( currentHash );

	// Add a listener for hash changes
	window.addEventListener( 'hashchange', () => mwfHashChangedHandler( window.location.hash ) );

	/**
	 * Handler for when hash changes
	 *
	 * @param {string} hash Window hash
	 */
	function mwfHashChangedHandler( hash ) {
		const href = hash.replace( '!', '' ); // Old URLs have #!. The "!" has issues with IDs that need to not have them for a11y.

		if ( '' !== href ) {
			const mwfNavTabActiveItem = document.querySelector( `a[href="${href}"]` );
			if ( mwfNavTabActiveItem ) {
				mwfNavTabActiveItem.click();
			}
		}
	}

	/**
	 * Initialization of tab group
	 * @param {object} singleMwfNavTabGroup - A single group of tabs
	 */
	function setupMwfNavTabDelegations( singleMwfNavTabGroup ) {
		singleMwfNavTabGroup.addEventListener( 'click', mwfNavTabLinkHandler );
		singleMwfNavTabGroup.addEventListener( 'transitionend', mwfNavTabCrossFadeHandler );
	}

	/**
	 * Link handler for tab group links
	 * @param {object} e - Event object
	 * @returns {void}
	 */
	function mwfNavTabLinkHandler( e ) {
		const href = e.target.getAttribute( 'href' );

		// Abandon if e.target doesn't contain a valid href target
		if ( !href || -1 === href.indexOf( '#' ) ) return;

		// Call the reset for tab links
		resetMwfNavTabLinks( e.currentTarget );

		// Call the reset for tab panels
		resetMwfNavTabPanels( e.currentTarget );

		// Set active tab link
		e.target.setAttribute( 'aria-current', 'true' );
		if( e.target.parentNode ) {
			e.target.parentNode.classList.add( 'active' );
		}

		// Set active panel
		const panel = document.getElementById( href.replace( '#','' ) );
		if( panel ) {
			panel.classList.add( 'active' );
			panel.classList.add( 'show' );
		}
	}

	/**
	 * Transition helper for smooth cross fade between panels
	 * @param {object} e - Event object
	 */
	function mwfNavTabCrossFadeHandler( e ) {
		const tabPanes = e.currentTarget.querySelectorAll( '.tab-pane' );
		tabPanes.forEach( tab => {
			if( !tab.classList.contains( 'show' ) ) {
				tab.classList.add( 'hidden' );
			} else {
				tab.classList.remove( 'hidden' );
			}
		} );
	}

	/**
	 * Reset handler to reset ui state of associated tab links
	 * @param {object} el - DOM element representing tab grouping
	 */
	function resetMwfNavTabLinks( el ) {
		const mwfNavTabLinks = el.querySelectorAll( '.nav-item' );
		mwfNavTabLinks.forEach( tab => {
			tab.classList.remove( 'active' );
			const link = tab.querySelector( 'a[role="tab"]' );
			if( link ) {
				link.removeAttribute( 'aria-current' );
			}
		} );
	}

	/**
	 * Reset handler to reset ui state of associated tab panels
	 * @param {object} el - DOM element representing tab grouping
	 */
	function resetMwfNavTabPanels( el ) {
		const mwfNavTabPanels = el.querySelectorAll( '.tab-pane' );
		mwfNavTabPanels.forEach( panel => {
			panel.classList.remove( 'active' );
			panel.classList.remove( 'show' );
		} );
	}
}() );
